import { Box, CircularProgress } from '@mui/material'
import { brand } from '../theme/palette.js'

export default function LoadingFallback() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress sx={{ color: brand.red }} />
    </Box>
  )
}
